import script from "./SanctionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SanctionsView.vue?vue&type=script&setup=true&lang=js"

import "./SanctionsView.vue?vue&type=style&index=0&id=1df913af&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df913af"]])

export default __exports__